// v2/hooks/useDashboard.js — /api/v2/dashboard/ (cariye ozel ana sayfa verisi)
import { useCallback, useEffect, useRef, useState } from 'react';
import { apiGet } from '../utils/api';
import { mapDashboard } from '../utils/mapDashboard';

export default function useDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const yenile = useCallback(async () => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    try {
      const veri = await apiGet('/v2/dashboard/', { signal: ctrl.signal });
      if (ctrl.signal.aborted) return;
      setData(mapDashboard(veri));
    } catch (e) {
      if (e && e.name === 'AbortError') return;
      // Onceki veri varsa ekranda kalsin, sadece hata bilgisi guncellensin
      setError(e.message || 'Veriler alınamadı');
    } finally {
      if (!ctrl.signal.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    yenile();
    return () => {
      if (abortRef.current) abortRef.current.abort();
    };
  }, [yenile]);

  return { data, loading, error, yenile };
}
